import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../variables/constants";
import { Form, Input, Button, Card, Typography, Checkbox } from 'antd';
import { UserOutlined, LockOutlined, KeyOutlined, ArrowLeftOutlined, MailOutlined, WhatsAppOutlined, PhoneOutlined, EnvironmentOutlined } from '@ant-design/icons';
import entete from "../../assets/img/entete_pool.png";
import poolins from "../../assets/img/poolins.jpg";

const { Title, Text, Paragraph } = Typography;

const FirstConnexion = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [termsAndConditionsCheck, setTermsAndConditionsCheck] = useState(false);
  const [insurances, setInsurances] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${API_URL}/api/organisme/all/assurances`).then(response => {
      if (response.data) {
        setInsurances(response.data);
      }
    }).catch(error => {
      console.error("Erreur lors de la récupération des logos des assurances:", error);
    });
  }, []);

  const getSessionToken = () => {
    const n = sessionStorage.getItem('n');
    const t = sessionStorage.getItem('t');
    const k = sessionStorage.getItem('k');
    return (n && t && k) ? `${n}.${t}.${k}` : null;
  };

  const handleSubmit = (values) => {
    if (!termsAndConditionsCheck) {
      toast.warning("Veuillez accepter les termes et conditions de PoolIns");
      return;
    }

    setLoading(true);
    const token = getSessionToken();

    if (!token) {
      toast.error("Session expirée. Veuillez vous reconnecter.");
      setLoading(false);
      navigate("/connexion", { replace: true });
      return;
    }

    axios
      .get(`${API_URL}/api/utilisateur/first-connexion/${values.email}/${values.newPassword.trim()}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(() => {
        setLoading(false);
        toast.success("Mot de passe défini avec succès");
        navigate("/connexion", { replace: true });
      })
      .catch((err) => {
        console.error(err);
        toast.error("Erreur lors de la définition du mot de passe");
        setLoading(false);
      });
  };

  return (
    <div style={{
      height: '100vh',
      backgroundImage: 'url(assets/img/landing.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(36, 33, 102, 0.12)',
        backdropFilter: 'blur(10px)',
        zIndex: 0
      }} />

      <ToastContainer position="top-center" />

      {/* Main content area */}
      <div style={{
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        position: 'relative',
        zIndex: 1,
        minHeight: 0
      }}>
        <div style={{
          width: '100%',
          maxWidth: '1400px',
          display: 'grid',
          gridTemplateColumns: '300px auto 300px',
          gap: '40px',
          alignItems: 'center'
        }}>
          {/* Left Section - PoolIns */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            alignItems: 'center'
          }}>
            <img
              src={poolins}
              alt="PoolIns"
              style={{
                maxWidth: '180px',
                width: '100%',
                height: 'auto',
                borderRadius: '16px',
                filter: 'drop-shadow(0 4px 12px rgba(0, 0, 0, 0.5))'
              }}
            />
            <Text style={{
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              display: 'block',
              fontStyle: 'italic',
              letterSpacing: '0.3px',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
              textAlign: 'center'
            }}>
              Solution intégrée des assurances
            </Text>
          </div>

          {/* Center Section - First Connection Form */}
          <Card style={{
            width: '520px',
            background: 'white',
            borderRadius: '24px',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.4)',
            border: 'none',
            overflow: 'hidden'
          }}>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #242166 0%, #3b82f6 100%)',
              padding: '24px 28px',
              marginTop: '-24px',
              marginLeft: '-24px',
              marginRight: '-24px',
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              <Title level={2} style={{
                color: 'white',
                margin: 0,
                fontSize: '24px',
                fontWeight: '700'
              }}>
                Bienvenue sur PoolIns
              </Title>
              <Text style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '13px'
              }}>
                Définissez votre mot de passe pour commencer
              </Text>
            </div>

            <div style={{ padding: '0 8px 8px' }}>
              {/* Message d'information */}
              <div style={{
                background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
                borderRadius: '12px',
                padding: '12px',
                marginBottom: '16px',
                border: '1px solid #bfdbfe'
              }}>
                <Paragraph style={{
                  margin: 0,
                  color: '#1e40af',
                  fontSize: '12px',
                  lineHeight: '1.5',
                  textAlign: 'center'
                }}>
                  Pour des raisons de sécurité, veuillez définir un nouveau mot de passe fort
                </Paragraph>
              </div>

              <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                autoComplete="off"
                requiredMark={false}
              >
                <Form.Item
                  label={<span style={{ color: '#242166', fontWeight: '600', fontSize: '13px' }}>Adresse email</span>}
                  name="email"
                  rules={[
                    { required: true, message: 'Adresse mail requise' },
                    { type: 'email', message: "L'adresse email n'est pas valide" }
                  ]}
                  style={{ marginBottom: '12px' }}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: '#242166' }} />}
                    placeholder="exemple@email.com"
                    size="large"
                    style={{
                      borderRadius: '12px',
                      border: '2px solid #e5e7eb',
                      padding: '10px 14px',
                      fontSize: '14px'
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ color: '#242166', fontWeight: '600', fontSize: '13px' }}>Mot de passe actuel</span>}
                  name="password"
                  rules={[{ required: true, message: 'Mot de passe requis' }]}
                  style={{ marginBottom: '12px' }}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: '#242166' }} />}
                    placeholder="••••••••"
                    size="large"
                    style={{
                      borderRadius: '12px',
                      border: '2px solid #e5e7eb',
                      padding: '10px 14px',
                      fontSize: '14px'
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ color: '#242166', fontWeight: '600', fontSize: '13px' }}>Nouveau mot de passe</span>}
                  name="newPassword"
                  rules={[
                    { required: true, message: 'Nouveau mot de passe requis' },
                    {
                      pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
                      message: 'Le mot de passe doit contenir au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.'
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') !== value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Votre nouveau mot de passe ne doit pas être le même que l\'ancien'));
                      },
                    }),
                  ]}
                  hasFeedback
                  style={{ marginBottom: '12px' }}
                >
                  <Input.Password
                    prefix={<KeyOutlined style={{ color: '#242166' }} />}
                    placeholder="••••••••"
                    size="large"
                    style={{
                      borderRadius: '12px',
                      border: '2px solid #e5e7eb',
                      padding: '10px 14px',
                      fontSize: '14px'
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={<span style={{ color: '#242166', fontWeight: '600', fontSize: '13px' }}>Confirmer le nouveau mot de passe</span>}
                  name="confirmNewPassword"
                  dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Veuillez confirmer votre mot de passe' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('newPassword') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Les mots de passe ne correspondent pas'));
                      },
                    }),
                  ]}
                  hasFeedback
                  style={{ marginBottom: '14px' }}
                >
                  <Input.Password
                    prefix={<KeyOutlined style={{ color: '#242166' }} />}
                    placeholder="••••••••"
                    size="large"
                    style={{
                      borderRadius: '12px',
                      border: '2px solid #e5e7eb',
                      padding: '10px 14px',
                      fontSize: '14px'
                    }}
                  />
                </Form.Item>

                <div style={{
                  background: '#f8fafc',
                  borderRadius: '12px',
                  padding: '12px',
                  marginBottom: '14px'
                }}>
                  <Checkbox
                    checked={termsAndConditionsCheck}
                    onChange={(e) => setTermsAndConditionsCheck(e.target.checked)}
                    style={{ width: '100%' }}
                  >
                    <Text style={{ color: '#475569', fontSize: '13px' }}>
                      J'accepte{' '}
                      <a
                        href="#"
                        onClick={(e) => e.preventDefault()}
                        style={{ color: '#242166', fontWeight: '600', textDecoration: 'none' }}
                      >
                        les termes et conditions
                      </a>
                    </Text>
                  </Checkbox>
                </div>

                <Form.Item style={{ marginBottom: '12px' }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    size="large"
                    block
                    style={{
                      background: 'linear-gradient(135deg, #242166 0%, #3b82f6 100%)',
                      borderRadius: '12px',
                      height: '46px',
                      fontSize: '15px',
                      fontWeight: '600',
                      border: 'none',
                      boxShadow: '0 4px 12px rgba(36, 33, 102, 0.3)',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    {loading ? 'Enregistrement...' : 'Définir le mot de passe'}
                  </Button>
                </Form.Item>

                <div style={{
                  textAlign: 'center',
                  padding: '12px',
                  background: '#f8fafc',
                  borderRadius: '12px'
                }}>
                  <a
                    href="/connexion"
                    style={{
                      color: '#242166',
                      textDecoration: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      fontWeight: '600',
                      fontSize: '13px'
                    }}
                  >
                    <ArrowLeftOutlined />
                    Déjà fait ? Connectez-vous !
                  </a>
                </div>
              </Form>
            </div>
          </Card>

          {/* Right Section - Placeholder for symmetry */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            alignItems: 'center'
          }}>
            {/* Pool Logo */}
            <div style={{
              background: 'white',
              borderRadius: '16px',
              padding: '24px',
              textAlign: 'center',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)'
            }}>
              <img
                src={entete}
                alt="Pool TPVM-VT GIE"
                style={{
                  width: '100%',
                  maxWidth: '280px',
                  height: 'auto'
                }}
              />
            </div>

            {/* Contact Information - directly on background */}
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '14px',
              width: '100%'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px'
              }}>
                <EnvironmentOutlined style={{
                  color: '#3b82f6',
                  fontSize: '20px',
                  marginTop: '2px',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }} />
                <Text style={{
                  color: 'white',
                  fontSize: '15px',
                  lineHeight: '1.6',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  fontWeight: '500'
                }}>
                  Rue Gérard DULPHY, Lomégan derrière Radio Pyramide<br />
                  01 B.P. 4866, Lomé - TOGO
                </Text>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <PhoneOutlined style={{
                  color: '#3b82f6',
                  fontSize: '20px',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }} />
                <Text style={{
                  color: 'white',
                  fontSize: '15px',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  fontWeight: '500'
                }}>
                  +228 92 62 66 66
                </Text>
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <WhatsAppOutlined style={{
                  color: '#25D366',
                  fontSize: '20px',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }} />
                <Text style={{
                  color: 'white',
                  fontSize: '15px',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  fontWeight: '500'
                }}>
                  +228 70 48 11 11
                </Text>
              </div>

              {/* Email */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px'
              }}>
                <MailOutlined style={{
                  color: '#3b82f6',
                  fontSize: '20px',
                  filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
                }} />
                <Text style={{
                  color: 'white',
                  fontSize: '15px',
                  textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                  fontWeight: '500'
                }}>
                  poolvtgie@pooltpv.tg
                </Text>
              </div>

              <div style={{
                marginTop: '12px',
                paddingTop: '16px',
                borderTop: '2px solid rgba(255, 255, 255, 0.3)',
                display: 'flex',
                flexDirection: 'column',
                gap: '10px'
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Text style={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: '14px',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                    fontWeight: '600'
                  }}>
                    NIF:
                  </Text>
                  <Text style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '600',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                  }}>
                    1000 16 1028
                  </Text>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Text style={{
                    color: 'rgba(255, 255, 255, 0.9)',
                    fontSize: '14px',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                    fontWeight: '600'
                  }}>
                    RCC:
                  </Text>
                  <Text style={{
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: '600',
                    textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                  }}>
                    2009 C 0771
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section - Company Logos Marquee */}
      <div style={{
        padding: '20px 0',
        position: 'relative',
        zIndex: 1,
        overflow: 'hidden'
      }}>
        <div style={{
          width: '100%',
          overflow: 'hidden',
          position: 'relative'
        }}>
          <style>
            {`
              @keyframes marquee {
                0% {
                  transform: translateX(0);
                }
                100% {
                  transform: translateX(-50%);
                }
              }
              
              .marquee-content {
                display: flex;
                gap: 30px;
                animation: marquee 30s linear infinite;
                will-change: transform;
              }
              
              .marquee-content:hover {
                animation-play-state: paused;
              }
              
              .company-logo-card {
                background: white;
                border-radius: 12px;
                padding: 16px;
                min-width: 140px;
                height: 85px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
                transition: transform 0.3s ease, box-shadow 0.3s ease;
                flex-shrink: 0;
              }
              
              .company-logo-card:hover {
                transform: translateY(-4px);
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
              }
            `}
          </style>

          <div className="marquee-content">
            {/* First set of logos */}
            {Array.isArray(insurances) && insurances.map((ins, i) => (
              <div key={`logo-1-${i}`} className="company-logo-card">
                <img
                  src={`data:image/png;base64,${ins.logoDisplay}`}
                  alt={ins.raisonSociale || `Logo ${i + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '60px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            ))}

            {/* Duplicate set for seamless loop */}
            {Array.isArray(insurances) && insurances.map((ins, i) => (
              <div key={`logo-2-${i}`} className="company-logo-card">
                <img
                  src={`data:image/png;base64,${ins.logoDisplay}`}
                  alt={ins.raisonSociale || `Logo ${i + 1}`}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '60px',
                    objectFit: 'contain'
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstConnexion;